let $window;

let React;
let StickyDiv;
let get_parameter_by_name;

React = require("react");

import Sticky from "react-stickynode";

get_parameter_by_name = require("../helpers/get_parameter_by_name").default;

$window = require("../helpers/helpers").default.window;

class SearchBar extends React.Component {
  constructor(props) {
    super(props);

    this.maxSuggestions = 4;
    this.minCharsForSuggestions = 2;
    this.suggestEndpoint = "/json_icon_list/autocomplete/?term=";
    this.suggestQuery = null;

    let is_homepage = false;

    if (props) {
      if (props.args.homepage) {
        is_homepage = props.args.homepage;
      }
    }

    this.state = {
      query: get_parameter_by_name("q"),
      oldQuery: null,
      creator: props.args === undefined
        ? get_parameter_by_name("creator")
        : props.args.creator,
      collection: props.args === undefined
        ? get_parameter_by_name("collection")
        : props.args.collection,
      dark: props.args === undefined ? undefined : props.args.dark,
      collectionsOnly: false,
      searchEverything: false,
      suggestions: [],
      selectedSuggestion: null,
      focused: false,
      autocompleteHover: false,
      homepage: is_homepage,
    };
  }

  getSuggestions(query) {
    if (this.suggestQuery) {
      this.suggestQuery.abort();
    }
    query = encodeURIComponent(query.trim());
    if (query === "") {
      return;
    }
    return this.suggestQuery = $.get(this.suggestEndpoint + query)
      .done(
        (_this => data => _this.setState({
          suggestions: data.slice(0, _this.maxSuggestions),
        }))(this),
      )
      .fail((xhr, status, error) => console.warn(error));
  }

  shouldGetSuggestions(query) {
    if (!query || query.length < this.minCharsForSuggestions) {
      return false;
    }
    if ($window.width() <= 768) {
      return false;
    }
    if (
      this.state.searchEverything === false &&
      (this.state.creator !== undefined || this.state.collection !== undefined)
    ) {
      return false;
    }
    return true;
  }

  updateQuery(event) {
    let query;
    let state;
    query = event.target.value.trim();
    state = {
      query: event.target.value,
      selectedSuggestion: null,
    };
    if (this.shouldGetSuggestions(query)) {
      this.getSuggestions(query);
    } else {
      state.suggestions = [];
    }
    return this.setState(state);
  }

  buildSuggestionList(suggestions) {
    let extraParams;
    let i;
    let len;
    let myClass;
    let query;
    let suggestionList;
    suggestionList = [];
    extraParams = "";
    if (this.state.searchEverything === false) {
      if (this.state.creator) {
        extraParams += "&creator=" + this.state.creator;
      }
      if (this.state.collection) {
        extraParams += "&collection=" + this.state.collection;
      }
    }
    for (i = 0, len = suggestions.length; i < len; i++) {
      query = suggestions[i];
      myClass = "suggestion";
      if (suggestionList.length === this.state.selectedSuggestion) {
        myClass += " active";
      }
      suggestionList.push(
        <li key={"suggestion." + suggestionList.length} className={myClass}>
          <a
            href={"/search/?q=" + query + extraParams}
            title={gettext("Search for ") + query}
          >
            {query}
          </a>
        </li>,
      );
    }
    return (
      <div className="container row">
        <ul id="autocomplete-list" className="autocomplete">
          {suggestionList}
        </ul>
      </div>
    );
  }

  buildScopeBadge(text) {
    if ($window.width() <= 768) {
      return void 0;
    }
    return (
      <div className="search-scope-badge">
        {text}
        <span
          className="ui_deny search-scope-cancel"
          onClick={this.setSearchEverything.bind(this)}
          title={gettext("Remove to search all of Noun Project")}
        />
      </div>
    );
  }

  autocompleteSelectNext() {
    let current;
    let next;
    if (this.state.suggestions.length === 0) {
      return;
    }
    current = this.state.selectedSuggestion;
    if (current === null) {
      next = 0;
      this.setState({
        query: this.state.suggestions[next],
        oldQuery: this.state.query,
        selectedSuggestion: 0,
      });
    } else if (current < this.state.suggestions.length - 1) {
      next = current + 1;
    } else {
      next = current;
    }
    return this.setState({
      query: this.state.suggestions[next],
      selectedSuggestion: next,
    });
  }

  autocompleteSelectPrevious() {
    let current;
    let next;
    if (this.state.suggestions.length === 0) {
      return;
    }
    current = this.state.selectedSuggestion;
    if (current === null || current === 0) {
      return this.setState({
        query: this.state.oldQuery,
        oldQuery: null,
        selectedSuggestion: null,
      });
    } else {
      next = current - 1;
      return this.setState({
        query: this.state.suggestions[next],
        selectedSuggestion: next,
      });
    }
  }

  setSearchEverything() {
    if (
      this.state.creator || this.state.collection || this.state.collectionsOnly
    ) {
      return this.setState({
        searchEverything: true,
      });
    }
  }

  unsetSearchEverything(e) {
    if (e) {
      e.preventDefault();
    }
    return this.setState({
      searchEverything: false,
    });
  }

  handleAutocompleteEnter() {
    return this.setState({
      autocompleteHover: true,
    });
  }

  handleAutocompleteLeave() {
    return this.setState({
      autocompleteHover: false,
    });
  }

  handleKeyup(event) {
    let codes;
    let keyCode;
    codes = {
      up: 38,
      down: 40,
      right: 39,
      left: 37,
      enter: 13,
    };
    keyCode = event.keyCode;
    if (keyCode === codes.up) {
      return this.autocompleteSelectPrevious();
    } else if (keyCode === codes.down) {
      return this.autocompleteSelectNext();
    }
  }

  handleKeydown(event) {
    let codes;
    let keyCode;
    let ref;
    codes = {
      delete: 46,
      backspace: 8,
    };
    keyCode = event.keyCode;
    if (keyCode === codes["delete"] || keyCode === codes.backspace) {
      if ((ref = this.state.query) === "" || ref === null) {
        return this.setSearchEverything();
      }
    }
  }

  componentWillMount() {
    let query;

    window.scrollTo(0, 0);

    query = $(".search-input").val();
    if (query && query.length > 0) {
      return this.setState({
        query: $(".search-input").val(),
      });
    }
  }

  componentDidMount() {
    this.$searchInput = $(".search-input");
    this.$searchInput.on("keyup", (_this => e => _this.handleKeyup(e))(this));
    this.$searchInput.on(
      "keydown",
      (_this => e => _this.handleKeydown(e))(this),
    );
    this.$searchInput.on(
      "focus",
      (_this => e => {
        let state;
        state = {
          focused: true,
        };
        if (!_this.shouldGetSuggestions(_this.state.query)) {
          state.suggestions = [];
        }
        return _this.setState(state);
      })(this),
    );
    this.$searchInput.on(
      "blur",
      (_this => e => _this.setState({
        focused: false,
      }))(this),
    );
    return this.setState({
      collectionsOnly: window.location.pathname === "/search/collection/"
        ? true
        : false,
    });
  }

  render() {
    let creatorInput;
    let darkClass;
    let form;
    let formAction;
    let homepageClass;
    let placeholder;
    let query = this.state.query;
    let restrictSearch;
    let scopeBadge;
    let suggestionBox;
    let suggestionList;
    let text;
    placeholder = gettext("Search for anything");
    formAction = "/search/";
    if (!this.state.searchEverything) {
      if (this.state.creator) {
        scopeBadge = this.buildScopeBadge(gettext("This user"));
        creatorInput = (
          <input type="hidden" name="creator" value={this.state.creator} />
        );
      }
      if (this.state.collection) {
        formAction = window.location.pathname;
        scopeBadge = this.buildScopeBadge(gettext("This collection"));
      }
      if (this.state.collectionsOnly) {
        formAction = window.location.pathname;
        scopeBadge = this.buildScopeBadge(gettext("Collections"));
      }
    }
    homepageClass = "";
    if (this.state.homepage) {
      homepageClass = " homepage";
    }
    darkClass = "";
    if (this.state.dark) {
      darkClass = " dark";
    }
    if (query === null) {
      query = undefined;
    }
    form = (
      <section id="search" className={"search-bar" + homepageClass + darkClass}>
        <div className="container row">
          <form
            action={formAction}
            type="GET"
            id="search-form"
            autoComplete="off"
          >
            <label htmlFor="search-input" className="ui_search search-label">
              {scopeBadge}
              <input
                className="search-input"
                id="search-input"
                type="text"
                name="q"
                role="search"
                autoComplete="off"
                placeholder={placeholder}
                value={query}
                onChange={this.updateQuery.bind(this)}
              />
            </label>
            {creatorInput}
          </form>
        </div>
      </section>
    );

    if (this.state.searchEverything) {
      if (this.state.creator) {
        text = "Restrict search to this user";
      }
      if (this.state.collection) {
        text = "Restrict search to this collection";
      }
      if (this.state.collectionsOnly) {
        text = "Restrict search to collections only";
      }
      restrictSearch = (
        <div className="search-restrict-container">
          <div className="container row">
            <a
              href="#"
              onClick={this.unsetSearchEverything.bind(this)}
              className="search-restrict-link"
            >
              {gettext(text)}
            </a>
          </div>
        </div>
      );
    }
    if (this.state.suggestions.length > 0) {
      suggestionList = this.buildSuggestionList(this.state.suggestions);
    }
    if (
      (this.state.focused || this.state.autocompleteHover) &&
      (restrictSearch || suggestionList)
    ) {
      suggestionBox = (
        <section
          id="autocomplete"
          onMouseLeave={this.handleAutocompleteLeave.bind(this)}
          onMouseEnter={this.handleAutocompleteEnter.bind(this)}
          className={"autocomplete-container autocomplete" + homepageClass}
        >
          {restrictSearch}
          {suggestionList}
        </section>
      );
    }
    return (
      <Sticky top="#header" innerZ={99} activeClass="searchbar stuck">
        {form}
        {suggestionBox}
      </Sticky>
    );
  }
}

export default SearchBar;
